import { render, staticRenderFns } from "./UpdateCredentials.vue?vue&type=template&id=382397d0&"
import script from "./UpdateCredentials.vue?vue&type=script&lang=js&"
export * from "./UpdateCredentials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports